var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 21C1 9.95431 9.9543 1 21 1V1C32.0457 1 41 9.95431 41 21V21C41 32.0457 32.0457 41 21 41V41C9.9543 41 1 32.0457 1 21V21Z",
    stroke: "#7956D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2929 14.2929C14.6834 13.9024 15.3166 13.9024 15.7071 14.2929L21 19.5858L26.2929 14.2929C26.6834 13.9024 27.3166 13.9024 27.7071 14.2929C28.0976 14.6834 28.0976 15.3166 27.7071 15.7071L22.4142 21L27.7071 26.2929C28.0976 26.6834 28.0976 27.3166 27.7071 27.7071C27.3166 28.0976 26.6834 28.0976 26.2929 27.7071L21 22.4142L15.7071 27.7071C15.3166 28.0976 14.6834 28.0976 14.2929 27.7071C13.9024 27.3166 13.9024 26.6834 14.2929 26.2929L19.5858 21L14.2929 15.7071C13.9024 15.3166 13.9024 14.6834 14.2929 14.2929Z",
    fill: "#7956D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelBtn);
export default __webpack_public_path__ + "static/media/cancelBtn.a781a4a201a57f06bae4a4eceea1020b.svg";
export { ForwardRef as ReactComponent };